import { Link } from "react-router-dom";
import { products, categories } from "../products";
import ProductCard from "../components/ProductCard";
import Seo from "../components/Seo";
import heroLab from "../assets/hero-lab.jpg";
import originVial from "../assets/origin-vial.jpg";

export default function Home() {
  const featured = products.slice(0, 6);

  return (
    <>
      <Seo
        title="Pharmaceutical-Grade Formulations · Berlin"
        description={`OLYMPUS MEDS — a reference catalog of ${products.length} pharmaceutical-grade AAS formulations across ${categories.length} categories. Engineered in Berlin, Germany. Showcase for reference only.`}
        path="/"
      />
      <section className="hero">
        <img src={heroLab} alt="" className="hero__photo" aria-hidden="true" />
        <div className="hero__scrim" />
        <div className="hero__marble" />
        <div className="hero__glow" />
        <div className="hero__inner">
          <div className="hero__eyebrow">
            <span>Berlin · Germany</span>
          </div>
          <h1 className="hero__title">
            Pharmaceutical precision.
            <br />
            Built in Berlin.
          </h1>
          <p className="hero__subtitle">
            A reference catalog of {products.length} oral, injectable, and blend formulations.
          </p>
          <div className="hero__actions">
            <Link to="/catalog" className="btn btn--primary">
              View Catalog
              <span className="btn__arrow">→</span>
            </Link>
            <Link to="/about" className="btn btn--ghost">
              About
            </Link>
          </div>
          <div className="hero__stats">
            <div className="hero__stat">
              <div className="hero__stat-num">{products.length}</div>
              <div className="hero__stat-label">Formulations</div>
            </div>
            <div className="hero__stat">
              <div className="hero__stat-num">{categories.length}</div>
              <div className="hero__stat-label">Categories</div>
            </div>
            <div className="hero__stat">
              <div className="hero__stat-num">EU</div>
              <div className="hero__stat-label">Sourced actives</div>
            </div>
            <div className="hero__stat">
              <div className="hero__stat-num">DE</div>
              <div className="hero__stat-label">Manufactured</div>
            </div>
          </div>
        </div>
      </section>

      <section className="featured">
        <div className="featured__inner">
          <div className="featured__heading">
            <span className="eyebrow">Featured</span>
            <h2 className="section-title">Selected Formulations</h2>
            <p className="section-sub">
              A glimpse of the catalog — foundational testosterones, cutting compounds, and master blends.
            </p>
          </div>
          <div className="product-grid">
            {featured.map((p) => (
              <ProductCard key={p.slug} product={p} />
            ))}
          </div>
          <div className="featured__cta">
            <Link to="/catalog" className="btn btn--primary">
              View all {products.length} formulations
              <span className="btn__arrow">→</span>
            </Link>
          </div>
        </div>
      </section>

      <section className="pillars">
        <div className="pillars__inner">
          <div className="pillars__heading">
            <span className="eyebrow">Three Pillars</span>
            <h2 className="section-title">The Olympus Standard</h2>
          </div>
          <div className="pillars__grid">
            <article className="pillar">
              <div className="pillar__glyph">01</div>
              <h3>Purity of Actives</h3>
              <p>
                Pharmaceutical-grade raw materials, sourced within the European Union and assayed against USP
                reference standards. No shortcuts. No substitutes.
              </p>
            </article>
            <article className="pillar">
              <div className="pillar__glyph">02</div>
              <h3>Sterile Craft</h3>
              <p>
                Formulations prepared under sterile conditions using certified solvents — pharmaceutical-grade MCT
                oil, benzyl alcohol, benzyl benzoate — with dosing validated to the milligram.
              </p>
            </article>
            <article className="pillar">
              <div className="pillar__glyph">03</div>
              <h3>Transparent Reference</h3>
              <p>
                Every product is documented with its pharmaceutical name, mechanism, classification, and storage
                conditions. A reference catalog, not a sales page.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="origin">
        <div className="origin__inner">
          <div className="origin__text">
            <span className="eyebrow">Berlin · Germany</span>
            <h2 className="section-title">Engineered in Berlin</h2>
            <p>
              From Berlin, OLYMPUS MEDS operates where European pharmaceutical tradition meets modern sterile
              manufacturing. Our compounds are produced with EU-sourced active substances, dissolved in certified
              pharmaceutical carriers, and finished to the precision standards of European cleanrooms.
            </p>
            <p>
              Every product is documented in full — chemistry, form, storage, purpose. A reference, not a sales pitch.
            </p>
            <Link to="/about" className="btn btn--outline">
              More about us →
            </Link>
          </div>
          <div className="origin__visual">
            <img src={originVial} alt="Amber pharmaceutical vial on black marble in a sterile lab" className="origin__photo" />
          </div>
        </div>
      </section>
    </>
  );
}
